// extracted by mini-css-extract-plugin
module.exports = {"crowdfunding":"CrowdFunding_crowdfunding__uNN1C"};